import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/web-methods',
      name: 'Webmethods',
      meta: {
        layout: 'webmethods'
      }
    },
    {
      path: '/',
      name: 'Login',
      component: () => import('@/components/Login'),
      meta: {
        layout: 'auth'
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/components/Register'),
      meta: {
        layout: 'auth'
      }
    },
    {
      path: '/404',
      meta: {
        layout: 'error'
      }
    },
    { path: '*',
      redirect: '/404'
    },
    // {
    //   path: '/profile',
    //   name: 'Profile',
    //   component: () => import('@/components/Profile')
    // },
    {
      path: '/mydata',
      name: 'MyData',
      component: () => import('@/components/cabinet/MyData'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('@/components/cabinet/Settings'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/professionaldata',
      name: 'ProfessionalData',
      component: () => import('@/components/cabinet/ProfessionalData'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/patients',
      name: 'Patients',
      component: () => import('@/components/treatment/patients/PatientsList'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/patient/visits',
      name: 'PatientVisits',
      component: () => import('@/components/treatment/patients/PatientVisits'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/patient/consultations',
      name: 'PatientConsultations',
      component: () => import('@/components/treatment/patients/PatientConsultations'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/patient/data',
      name: 'PatientData',
      component: () => import('@/components/treatment/patients/PatientData'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/patient/emc',
      name: 'PatientEmc',
      component: () => import('@/components/treatment/patients/PatientEmc'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/consultations',
      name: 'Consultations',
      component: () => import('@/components/treatment/consultations/ConsultationsList'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/diagnostics',
      name: 'Diagnostics',
      component: () => import('@/components/treatment/consultations/Diagnostics'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/pharmpassport',
      name: 'PharmPassport',
      component: () => import('@/components/treatment/consultations/PharmPassport'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/recommendations',
      name: 'Recommendations',
      component: () => import('@/components/treatment/consultations/Recommendations'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/results',
      name: 'Results',
      component: () => import('@/components/treatment/consultations/Results'),
      meta: {
        layout: 'default'
      },
      props: true
    },
    {
      path: '/vital-characteristics',
      name: 'VitalCharacteristics',
      component: () => import('@/components/information/VitalCharacteristics'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/about-company',
      name: 'AboutCompany',
      component: () => import('@/components/information/AboutCompany'),
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/about-system',
      name: 'AboutSystem',
      component: () => import('@/components/information/AboutSystem'),
      meta: {
        layout: 'default'
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/register', '/web-methods'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = Store.getters['Auth/getAccessToken'];
  // console.log(authRequired)
  // console.log(loggedIn)
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/');
  } else {
    next();
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js